<app-modal-header (closeModal)="close()"> </app-modal-header>
@defer (when reasons.length > 0) {
  <app-modal-body>
    <h1 class="fs-5 text-truncate pe-2" [innerHTML]="'HOLD_ON' | translate"></h1>
    <p>
      {{ 'DO_YOU_REALLY_WANT_TO_DECLINE_THIS_REQUEST' | translate }}
    </p>
    <div>
      <select name="reason" class="form-select" [(ngModel)]="reasonSelected" (change)="onChangeReason($event)">
        @for (value of reasons; track $index) {
          <option [value]="$index">{{ value }}</option>
        }
      </select>
    </div>
    @if (reasonSelected === reasons.length - 1) {
      <div class="mt-2">
        <label for="otherReason" class="form-label">
          <i class="ri-arrow-down-s-line fs-5"></i>
          {{ otherReason.length }}/100
        </label>
        <textarea
          [(ngModel)]="otherReason"
          class="form-control no-resize"
          id="otherReason"
          name="otherReason"
          rows="3"
        ></textarea>
        @if (otherReason.length > 100) {
          <p class="mb-0 text-danger fs-13px mt-2">
            {{ 'PLEASE_KEEP_YOUR_MESSAGE_TO_X_LETTERS' | translate: { length: 100 } }}
          </p>
        }
      </div>
    }
  </app-modal-body>
  <app-modal-footer classList="d-flex justify-content-center align-items-center">
    <button
      class="btn btn-primary rounded-5"
      (click)="declineRequest()"
      [disabled]="isHttpRequestRunning && activeButton === ActiveButton.DECLINE_MEETING"
    >
      @if (isHttpRequestRunning && activeButton === ActiveButton.DECLINE_MEETING) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ 'DECLINE_REQUEST' | translate }}
    </button>

    @if (!isExternalMode) {
      <button
        class="btn rounded-5"
        (click)="close()"
        [class.btn-outline-dark]="!isBgDarkMode"
        [class.btn-outline-light]="isBgDarkMode"
      >
        {{ 'NO_GO_BACK' | translate }}
      </button>
    }
    @if (errorMessage) {
      <div class="d-flex justify-content-center w-100">
        <span class="text-danger mt-2">{{ errorMessage | translate }}</span>
      </div>
    }
  </app-modal-footer>
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <app-skeleton-general-list [count]="5" />
    </app-modal-body>
  }
}
